/**
 * Helper for event handling
 * @module lib/events
 */

/**
 * Checks whether the given event has any modifier (Ctrl, Shift, Alt, meta)
 * or is a right click
 * @param {MouseEvent} event
 */
export function hasModifiers(event) {
  return (
    event.which > 1 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  );
}

/**
 * Creates a function that only runs the given `handler` if the event it receives
 * is within the given `selector`
 * @param {String} selector - A CSS selector the event target should be or be within
 * @param {Function} handler - The function that actually handles the event.
 *                             It'll receive the element matching the selector as a second parameter
 * @returns {Function}
 */
export function delegate(selector, handler) {
  return event => {
    const target =
      (event.target.matches(selector) && event.target) ||
      // TODO: Add polyfill for IE 10/11
      event.target.closest(selector);
    if (target) {
      handler(event, target);
    }
  };
}

/**
 * Creates a function that only runs the given `handler` if the event it receives
 * is the given `target`
 * @param {HTMLElement} target
 * @param {Function} handler
 * @returns {Function}
 */
export function on(target, handler) {
  return event => {
    if (event.target == target) {
      handler(event);
    }
  };
}

/**
 * Creates a function that only runs the given `handler` if the event it receives
 * is the given `target` and not one of its pseudo element.
 *
 * This helps with `transitionend` events that Chrome send both for the target itself
 * and its pseudo elements.
 * @param {HTMLElement} target
 * @param {Function} handler
 * @returns {Function}
 */
export function onTransitionEndOn(target, handler) {
  return event => {
    if (event.target == target && !event.pseudoElement) {
      handler(event);
    }
  };
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/events.js